import FormattedMessage from 'I18n/components/FormattedMessage';
import { Header } from 'foundations-components/transitional/components/Header';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useHistory } from 'react-router-dom';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const TagManagerHeader = ({
  alert
}) => {
  const history = useHistory();
  return /*#__PURE__*/_jsx(Header, {
    breadcrumbs: /*#__PURE__*/_jsx(Breadcrumbs, {
      children: /*#__PURE__*/_jsx(Link, {
        onClick: () => history.push('/'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.tagManager.header.backLink"
        })
      })
    }),
    details: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reports.tagManager.header.description"
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reports.tagManager.header.title"
    }),
    flush: true,
    alert: alert,
    children: /*#__PURE__*/_jsx(Button, {
      use: "primary",
      size: "sm",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reports.tagManager.labels.createTag"
      })
    })
  });
};
export default TagManagerHeader;